import { render, staticRenderFns } from "./PassSidebar.vue?vue&type=template&id=56df2b56&scoped=true&"
import script from "./PassSidebar.vue?vue&type=script&lang=js&"
export * from "./PassSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PassSidebar.vue?vue&type=style&index=0&id=56df2b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df2b56",
  null
  
)

export default component.exports